import { getApp, getApps, initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';

function createFirebaseApp() {
  if (getApps().length) return getApp();
  return initializeApp({
    appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '',
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
    authDomain: typeof window !== 'undefined' ? window.location.host : '',
    projectId: import.meta.env.VITE_GOOGLE_CLOUD_PROJECT ?? 'demo-test',
  });
}

const app = createFirebaseApp();
export const auth = getAuth(app);

if (import.meta.env.VITE_GOOGLE_CLOUD_PROJECT === 'demo-test') {
  const authEmulatorHost =
    typeof window !== 'undefined' ? window.location.hostname : '127.0.0.1';
  connectAuthEmulator(auth, `http://${authEmulatorHost}:9099`, { disableWarnings: true });
}

const defaultTenantId = import.meta.env.VITE_FIREBASE_DEFAULT_TENANT_ID;
if (!defaultTenantId) {
  throw new Error('VITE_FIREBASE_DEFAULT_TENANT_ID is required');
}
auth.tenantId = defaultTenantId;
